import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px text-black-lp-300 overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 space-y-6 w-3/5" }
const _hoisted_3 = { class: "flex flex-row gap-3" }
const _hoisted_4 = { class: "text-12px text-gray-lp-600 mt-3" }
const _hoisted_5 = { class: "text-12px text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_multiple_file = _resolveComponent("multiple-file")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_detail_layout = _resolveComponent("detail-layout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalStatusPusatResolusi = _resolveComponent("ModalStatusPusatResolusi")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_detail_layout, {
        title: _ctx.$t('pusatResolusi.create.reportNewIssue'),
        fullPage: true,
        verticalSeparator: false,
        leavePageConfirmation: _ctx.leavePageConfirmation,
        "onUpdate:leavePageConfirmation": _cache[6] || (_cache[6] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
        onBack: _ctx.onBack,
        onLeavePage: _ctx.goBack
      }, {
        data: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_data_wrapper, {
              label: _ctx.$t('pusatResolusi.filterCategory'),
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  options: _ctx.categoryList,
                  onFilter: _ctx.filterCategories,
                  keyName: "name",
                  keyValue: "name",
                  placeholder: _ctx.$t('pusatResolusi.create.typeOrChoose'),
                  modelValue: _ctx.form.category,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.category = $event)),
                  onChange: _ctx.onSelectCategory,
                  class: "w-full whitespace-no-wrap my-2 z-10"
                }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_data_wrapper, {
              label: _ctx.labelStt,
              asterisk: ""
            }, {
              default: _withCtx(() => [
                (_ctx.isPickupProblem)
                  ? (_openBlock(), _createBlock(_component_lp_input, {
                      key: 0,
                      modelValue: _ctx.form.shipment,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.shipment = $event)),
                      placeholder: _ctx.$t('pusatResolusi.create.noShipment'),
                      error: _ctx.isShipmentValid,
                      errorCaption: _ctx.reasonShipmentValidate,
                      onChange: _ctx.checkValidateShipment,
                      maxLength: 25,
                      disabled: !_ctx.form.category?.value
                    }, null, 8, ["modelValue", "placeholder", "error", "errorCaption", "onChange", "disabled"]))
                  : (_openBlock(), _createBlock(_component_lp_input, {
                      key: 1,
                      modelValue: _ctx.form.stt,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.stt = $event)),
                      placeholder: _ctx.$t('pusatResolusi.create.noStt'),
                      error: _ctx.isSttValid,
                      errorCaption: _ctx.reasonSttValidate,
                      onChange: _ctx.checkValidateStt,
                      maxLength: 25,
                      disabled: _ctx.isQueryParams || !_ctx.form.category?.value
                    }, null, 8, ["modelValue", "placeholder", "error", "errorCaption", "onChange", "disabled"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_data_wrapper, {
              label: _ctx.$t('pusatResolusi.create.ticketDesc'),
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.description = $event)),
                  type: "textarea",
                  maxLength: 1000,
                  placeholder: _ctx.$t('pusatResolusi.create.writeUrReply'),
                  showMaxLength: ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_data_wrapper, {
              label: _ctx.$t('pusatResolusi.create.photoProof'),
              optional: ""
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode(_component_UploadImageTiny, {
                        title: photo,
                        modelValue: _ctx.form.attachmentImage[index],
                        "onUpdate:modelValue": ($event: any) => (_ctx.form.attachmentImage[index] = $event),
                        maxSize: 5
                      }, null, 8, ["title", "modelValue", "onUpdate:modelValue"])
                    ]))
                  }), 128))
                ]),
                _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('pusatResolusi.create.photoProofDesc')), 1),
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('pusatResolusi.create.logisticsDocumentationPhotoTwo')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_data_wrapper, {
              label: _ctx.$t('pusatResolusi.history.attachment'),
              optional: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_multiple_file, {
                  modelValue: _ctx.form.attachmentFile,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.attachmentFile = $event)),
                  maxSize: 16,
                  maxFile: 2,
                  type: ".doc, .docx, .pdf, .xlsx, .xls,",
                  caption: _ctx.$t('pusatResolusi.create.doxMaxSizeDesc')
                }, null, 8, ["modelValue", "caption"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_data_wrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_lp_button, {
                  title: _ctx.$t('pusatResolusi.create.reportIt'),
                  textColor: "white",
                  disabled: _ctx.isDisabled,
                  onClick: _ctx.onSubmitConfirmation
                }, null, 8, ["title", "disabled", "onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["title", "leavePageConfirmation", "onBack", "onLeavePage"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.isConfirmationSubmit ? _ctx.onSubmit : _ctx.onReport,
      onClose: _ctx.cancelCreate,
      title: _ctx.isConfirmationSubmit ? _ctx.$t('pusatResolusi.create.isReportDone') : _ctx.$t('pusatResolusi.create.sttNoIsReported'),
      message: _ctx.isConfirmationSubmit ? _ctx.$t('pusatResolusi.create.makesureDetail') : _ctx.$t('pusatResolusi.create.lookatStatus') ,
      image: _ctx.isConfirmationSubmit ? 'badge-confirmation-general' : 'image-modal-failed',
      textSuccess: _ctx.isConfirmationSubmit ? _ctx.$t('pusatResolusi.create.yes') : _ctx.$t('pusatResolusi.create.seeReport'),
      textCancel: _ctx.isConfirmationSubmit ?  _ctx.$t('pusatResolusi.create.cancel') : _ctx.$t('pusatResolusi.create.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.confirmation]
    ]),
    _createVNode(_component_ModalStatusPusatResolusi, { noTicket: _ctx.noTicket }, null, 8, ["noTicket"])
  ], 64))
}